var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.getIsLoading)?_c('div',{staticClass:"preloader"},[_c('div',{staticClass:"is-spinner"},[_c('Spinner',{attrs:{"color":"#ccc","size":150}})],1)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }